import { Aufnahmebogen } from './Aufnahmebogen';
import { IDs } from '../../../helpers/IDs';

export class AufnahmebogenStrom extends Aufnahmebogen {

    protected dataIgnored: any = {};
    private readonly entities: any = {
        'Eigenstromgeneration': IDs.ENT_ENERGIEDATEN_EIGENSTROM
    };

    constructor(dataSheet: Array<any>, dataDb: any) {
        super(dataSheet, dataDb);

        if (dataSheet.length) {
            this.initData(IDs.ENT_ENERGIEDATEN_STROM);
            this.setJahre();
            this.setData();
        }
    }

    public getData(): Array<any> {
        const data: any = this.data;

        Object.keys(data).forEach((entity: any) => {
            data[entity] = this.getDataValided(data[entity]);
            const compare: Array<any> = this.dataIgnored[entity].map((item: any) => item.jahr);
            data[entity] = data[entity].filter((row: any) => compare.indexOf(row.jahr) === -1);
        });

        return data;
    }

    protected getDataValided(data: Array<any>): Array<any> {
        return data.filter((row: any) =>
            row.co2_emissionen
            || row.einspeiseverguetung
            || row.gesamtproduktion_kwh
            || row.kosten_netto
            || row.spitzenlast
            || row.verbrauch_kwh
        );
    }

    private setData(): void {
        this.dataSheet.forEach((row: Array<string>, index: number) => {
            this.curRowIndex = index;
            const titel: string = this.getTitel() || null;

            if (this.isHeaderRow(row)) {
                this.initData(this.entities[titel] || IDs.ENT_ENERGIEDATEN_STROM);
                this.setJahre();
            } else if (index > 0) {
                this.setBemerkung();
            }

            switch (titel) {
                case 'Abrechnungszeitraum':
                    this.setAbrechnungszeitraum();
                    break;
                case 'Stromverbrauch':
                    this.setStromverbrauch();
                    break;
                case 'Stromkosten (netto)':
                    this.setValue('kosten_netto', (value: any, index: number) => {
                        if (typeof value === 'number') {
                            this.data[this.curEntity][index].kosten_netto = +value.toFixed(2);
                        }
                    });
                    break;
                case 'Spitzenlast':
                    this.setValue('spitzenlast', (value: any, index: number) => {
                        if (typeof value === 'number') {
                            this.data[this.curEntity][index].spitzenlast = +value.toFixed(2);
                        }
                    });
                    break;
                case 'CO2-Emissionen (Versorger-Strom)':
                    this.setValue('co2_emissionen', (value: any, index: number) => {
                        if (typeof value === 'number') {
                            this.data[this.curEntity][index].co2_emissionen = +value.toFixed(2);
                        }
                    });
                    break;
                case '-->  Gesamtproduktion Anlage':
                    this.setValue('gesamtproduktion_kwh', (value: any, index: number) => {
                        if (typeof value === 'number') {
                            this.data[this.curEntity][index].gesamtproduktion_kwh = +value.toFixed(2);
                        }
                    });
                    break;
                case '-->  Netzeinspeisung':
                    this.setNetzeinspeisung();
                    break;
                case '-->  Vergütung':
                    this.setValue('einspeiseverguetung', (value: any, index: number) => {
                        if (typeof value === 'number') {
                            this.data[this.curEntity][index].einspeiseverguetung = +value.toFixed(2);
                        }
                    });
                    break;
                case 'Mess-System (Kalibrierung)':
                    this.setValue('messsystem');
                    break;
            }
        });
        this.setDataIgnored();
    }

    private setDataIgnored(): void {
        const entity: string = IDs.ENT_ENERGIEDATEN_STROM;
        const entity2: string = IDs.ENT_ENERGIEDATEN_EIGENSTROM;
        const data: any = this.getDataValided(this.data[entity] || []);
        this.dataIgnored[entity] = [];
        this.dataIgnored[entity2] = [];

        data.forEach((row: any, index: number) => {
            const jahr: number = row.jahr || null;

            if (this.dataDb[entity].some((row: any) => row.jahr === jahr)) {
                this.dataIgnored[entity].push(data[index]);
                this.dataIgnored[entity2].push(data[index]);
            }
        });
    }

    protected setNetzeinspeisung(): void {
        this.setValue('netzeinspeisung_kwh', (value: any, index: number) => {
            const gesamtproduktion: number = +this.data[this.curEntity][index].gesamtproduktion_kwh || 0;
            const eigenverbrauch: number = gesamtproduktion > 0 && +value > 0 && (gesamtproduktion > +value)
                ? gesamtproduktion - +value
                : null;

            if (typeof value === 'number') {
                this.data[this.curEntity][index].netzeinspeisung_kwh = +value.toFixed(2);
            }

            if (typeof eigenverbrauch === 'number') {
                this.data[this.curEntity][index].eigenverbrauch_kwh = +eigenverbrauch.toFixed(2);
            }

            if (+eigenverbrauch > 0 && +eigenverbrauch < gesamtproduktion) {
                this.data[this.curEntity][index].eigenverbrauchsquote = +((+eigenverbrauch / gesamtproduktion) * 100).toFixed(2)
            }
        });
    }

    protected setStromverbrauch(): void {
        this.setValue('verbrauch_kwh', (value: any, index: number) => {
            if (typeof value === 'number') {
                this.data[this.curEntity][index].verbrauch_kwh = +value.toFixed(2);
            }
        });
    }
}
